import { put, takeEvery } from "redux-saga/effects";
import { mauPhieuThuCauHinhApi } from "../../../api/category/mauPhieuThuCauHinhApi";
import { mauPhieuThuCauHinhActions } from "../../actions/category/mauPhieuThuCauHinhActions";
import * as types from "../../action-types/category/mauPhieuThuCauHinhActionTypes";
import { NotifyHelper } from "../../../helpers/toast";

export function* selectAllSaga(): any {
  try {
    const response = yield mauPhieuThuCauHinhApi.selectAll();
    const data = response?.data || response || [];
    yield put(mauPhieuThuCauHinhActions.SELECT_ALL_SUCCESS(data));
  } catch (error: any) {
    const message = error?.message || "Lỗi tải danh sách mẫu phiếu";
    yield put(mauPhieuThuCauHinhActions.SELECT_ALL_ERROR(message));
    NotifyHelper.Error(message);
  }
}

export function* selectByIdSaga(action: any): any {
  try {
    const response = yield mauPhieuThuCauHinhApi.selectById(action.payload);
    const data = response?.data || response;
    yield put(mauPhieuThuCauHinhActions.SELECT_BY_ID_SUCCESS(data));
  } catch (error: any) {
    const message = error?.message || "Lỗi tải thông tin mẫu phiếu";
    yield put(mauPhieuThuCauHinhActions.SELECT_BY_ID_ERROR(message));
    NotifyHelper.Error(message);
  }
}

export function* insertSaga(action: any): any {
  try {
    const response = yield mauPhieuThuCauHinhApi.create(action.payload);
    const id = response?.data || response;
    if (id) {
      const dataResponse = yield mauPhieuThuCauHinhApi.selectById(id);
      const data = dataResponse?.data || dataResponse;
      yield put(mauPhieuThuCauHinhActions.INSERT_SUCCESS(data));
      NotifyHelper.Success("Tạo mẫu phiếu thành công");
      yield put(mauPhieuThuCauHinhActions.SELECT_ALL());
    }
  } catch (error: any) {
    const message = error?.message || "Lỗi tạo mẫu phiếu";
    yield put(mauPhieuThuCauHinhActions.INSERT_ERROR(message));
    NotifyHelper.Error(message);
  }
}

export function* updateSaga(action: any): any {
  try {
    const response = yield mauPhieuThuCauHinhApi.update(action.payload);
    const success = response?.data?.is_success || response?.is_success;
    if (success) {
      const dataResponse = yield mauPhieuThuCauHinhApi.selectById(
        action.payload.id_mau_phieu_thu,
      );
      const data = dataResponse?.data || dataResponse;
      yield put(mauPhieuThuCauHinhActions.UPDATE_SUCCESS(data));
      NotifyHelper.Success("Cập nhật mẫu phiếu thành công");
      yield put(mauPhieuThuCauHinhActions.SELECT_ALL());
    }
  } catch (error: any) {
    const message = error?.message || "Lỗi cập nhật mẫu phiếu";
    yield put(mauPhieuThuCauHinhActions.UPDATE_ERROR(message));
    NotifyHelper.Error(message);
  }
}

export function* deleteSaga(action: any): any {
  try {
    const response = yield mauPhieuThuCauHinhApi.delete(action.payload);
    const success = response?.data?.is_success || response?.is_success;
    if (success) {
      yield put(mauPhieuThuCauHinhActions.DELETE_SUCCESS(action.payload));
      NotifyHelper.Success("Xóa mẫu phiếu thành công");
      yield put(mauPhieuThuCauHinhActions.SELECT_ALL());
    }
  } catch (error: any) {
    const message = error?.message || "Lỗi xóa mẫu phiếu";
    yield put(mauPhieuThuCauHinhActions.DELETE_ERROR(message));
    NotifyHelper.Error(message);
  }
}

export function* mauPhieuThuCauHinhSaga(): any {
  yield takeEvery(types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL, selectAllSaga);
  yield takeEvery(types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID, selectByIdSaga);
  yield takeEvery(types.MAU_PHIEU_THU_CAU_HINH_INSERT, insertSaga);
  yield takeEvery(types.MAU_PHIEU_THU_CAU_HINH_UPDATE, updateSaga);
  yield takeEvery(types.MAU_PHIEU_THU_CAU_HINH_DELETE, deleteSaga);
}
